export default __webpack_public_path__ + "static/media/rect.06327dcd.svg";